export const WeedMaintenance = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="19" y="8" width="10" height="16" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M21.9997 8.00005V4H25.9997V8.00005" stroke="currentColor" stroke-width="2"/>
<circle cx="24" cy="16" r="2" stroke="currentColor" stroke-width="2"/>
<rect x="14.5" y="3.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="11.5" y="3.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="8.5" y="3.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="8.5" y="6.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="8.5" y="9.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<rect x="11.5" y="6.5" width="1" height="1" fill="currentColor" stroke="currentColor"/>
<path d="M12 23H10V21C10 19.3431 11.3431 18 13 18H15V20C15 21.6569 13.6569 23 12 23Z" stroke="currentColor" stroke-width="2"/>
<path d="M2 30H16" stroke="currentColor" stroke-width="2"/>
<path d="M8 23H10V21C10 18.2386 7.76142 16 5 16H3V18C3 20.7614 5.23858 23 8 23Z" stroke="currentColor" stroke-width="2"/>
<path d="M10 29.5V21" stroke="currentColor" stroke-width="2"/>
</svg>`;
